<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-dialog(
      v-model="dialogDraft",
      width="500"
     )
      v-card.pa-10
        v-row.justify-end
          v-icon(@click="dialogDraft=false") mdi-close
        v-text-field(
          :label="$t('Shipment.draftName')",
          v-model="draftName"
         )
        v-row.justify-center.pb-7
          v-btn(color="primary", @click="saveAsDraft", :disabled="loading") {{$t('Common.saveAsDraft')}}
        v-row.justify-center.align-center
          v-icon(color="error") mdi-alert
          h4 {{$t('Common.warningDraftFiles')}}
    v-dialog(
      v-model="dialogWarningFiles",
      persistent
      width="500"
     )
      v-card.pa-10
        v-row.justify-center.align-center
          v-icon(color="error") mdi-alert
          h4 {{$t('Common.warningFiles')}}
        v-row.justify-center.pb-7.pt-7
          v-btn(color="primary", @click="redirectAfterSave", :disabled="loading") {{$t('Common.ok')}}


    //- v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    //-   v-col.py-0.text-right
    //-     v-btn.mr-2(color="white", @click="save()", :disabled="loading || isSubmitDisabled || blockEdit") Submit
    //-     v-btn(v-if="hasDraftPermission" color="white", @click="dialogDraft = true", :disabled="loading") Save as Draft
    p.v-messages__message(v-if="documentErrors == true", style="color:white")  {{$t('Shipment.requiredFiles')}}
    v-row(v-show="!loading")
      v-col.py-0
        //- v-card.elevation-24.mb-5(style="overflow: hidden")
        //app-full-entity(:isDraft="isDraft", :entity="portalFinalObject", :errors="errors", :ignoreTabs="shipmentIgnoreTabs", v-bind="{ customLabel, tabsWithErrors, disregardErrorInTabs: tabsWithoutErrors }")
        app-entity-stepper(v-if="!loading", @redirectToIndex="redirectToIndex", :disableSubmit="(isSubmitDisabled || !hasSubmitPermission) || blockEdit", :hasDraftPermission="hasDraftPermission", @saveAsDraft="dialogDraft = true", @submit="save()", :isEditing="isEditing", :entity="portalFinalObject", :errors="errors", :ignoreTabs="shipmentIgnoreTabs", v-bind="{ customLabel, tabsWithErrors, disregardErrorInTabs: tabsWithoutErrors }")
          template(v-slot:Shipment="props")
            shipment-general(:entity="portalFinalObject" :slotProps="props" v-bind="{ errors, isASN, loading }")
          template(v-slot:pickupDelivery="props")
            pickup-delivery(:slotProps="props", :shipmentFields="(portalFinalObject || {}).fields", v-bind="{ errors, isASN }")
          template(v-slot:packages="props")
            packages(v-bind="{ ...props, reverseMap: !!instance.uid, isDraft: isDraft }")
          template(v-slot:shipmentItems="props")
            shipment-items(v-bind="{...props, reverseMap: !!instance.uid, isDraft: isDraft }")
          template(v-slot:carrierSelection="props")
            carrier-selection(:slotProps="props", @save="save")
          template(v-slot:quotes="props")
            quotes(v-bind="{...props, parentInstance: instance }")
          template(v-slot:files="{ isActive }")
            document-request(:localFiles="filesToUpload", :localForm="filesFormData", :entity="shipmentEntity", :parentInstance="instance", @sendFiles="handleFiles", :instance="instance", :isActive="isActive")
          template(v-slot:comments="props")
            shipment-comments(:shipmentId="instance && instance.id", :shipmentBusinessScopeId="instance.businessScopeId", @update:comments="updateComments")
          template(v-slot:summary="props")
            summary-shipment(:entity="shipmentEntity", :parentInstance="instance", :instance="instance")
</template>

<script>
import moment from 'moment-timezone'
import axios from 'axios'
import EntityMixin from '@/mixins'
import DraftMixin from '@/mixins/DraftMixin'
import isEmpty from 'lodash/isEmpty';
import ShipmentComments from '@/components/Shipment/Comments';
import PickupDelivery from '@/components/Shipment/PickupDelivery';
import ShipmentGeneral from '@/components/Shipment/General';
import ShipmentQuote from '@/components/Shipment/Quote';
import CarrierSelection from '@/components/Shipment/CarrierSelection';

export default {
  mixins: [EntityMixin, DraftMixin],
  name: 'shipment-add',
  components: {
    ShipmentComments,
    PickupDelivery,
    ShipmentGeneral,
    ShipmentQuote,
    CarrierSelection,
  },
  data: function () {
    return {
      loading: true,
      dialogDraft: false,
      dialogWarningFiles: false,
      draftName: null,
      errors: {},
      documentErrors : false,
      isASN : false,
      isSubmitDisabled: false,
      isFirstLoad: true,
      processes: [],
      filesToUpload: [],
      shipmentBusinessScopeId: null,
      shipmentBusinessScope: {},
      permIgnore: ['businessScope', 'shipmentContacts', 'partyFrom', 'partyTo', 'recommended', 'legs'],
      onAddIgnore: ['comments', 'responsibilities'],
      tabsOrder: ['pickupDelivery', 'packages', 'shipmentItems', 'files', 'carrierSelection', 'quotes', 'responsibilities', 'comments'], // order for the first tabs
      endTabs: ['files', 'responsibilities', 'comments', 'history'], // go after extra data according to design
      customAdditionalTabs: [
        { name: "pickupDelivery" , type: "pickupDelivery", fields:[]},
        { name: "carrierSelection" , type: "carrierSelection", fields:[]},
      ],
      menu2: false,
      date: null,
      tabsWithErrors: [],
      tabsWithoutErrors: [],
      loads: [
        'ShipmentContacts.Contact',
        'ShipmentItems.ExtraData',
        'ShipmentItems.OrderLine',
        'ShipmentItems.Product',
        'ExtraData',
        'PartyFrom.ExtraData',
        'PartyTo.ExtraData',
        'BusinessScope',
        'User',
        'Comments.User',
        'Packages.PackageContents',
        'Packages.PackageContents.OrderLine',
        'Packages.ExtraData',
        'Packages.Status',
        'Files',
        'Status',
        'Quotes.Leg',
        'Quotes.Status',
        'Quotes.ExtraData',
        'Quotes.QuoteItems.ExtraData',
        'Legs',
      ],
      asnShipment: {},
      initShipmentItems: [],
      blockEdit: false,
      filesFormData: null,
    }
  },
  watch: {
    'instance.datePickupFrom': {
      immediate: true,
      handler(val) {
        if(this.isASN){
          if(moment(this.instance.datePickupFrom).format('MM/DD/YYYY') < moment().format('MM/DD/YYYY')){
            this.isSubmitDisabled = true
          }else{
            this.isSubmitDisabled = false
          }
        }
      },
    },
    'instance.shipmentContacts': {
      immediate: true,
      handler(val) {
        if(this.isASN){
          if(this.instance.shipmentContacts && this.instance.shipmentContacts.filter(x => x.contactType == 0).length > 0){
            this.isSubmitDisabled = false
          }else{
            this.isSubmitDisabled = true
          }
        }
      },
    }
  },
  computed: {
    hasSubmitPermission() {
      if (this.uid)
        return this.$store.state.schema.all.find(e => e.name == this.entityName).actions.edit;
      return this.$store.state.schema.all.find(e => e.name == this.entityName).actions.create;
    },
    portal() {
      return this.$route.params.portal
    },
    quoteIgnore() {
      let legs = _.get(this.instance, 'legs', []);
      return legs.length > 0 ? [] : ['carrierSelection'];
    },
    customLabel() {
      return ({
        partyFrom: this.$t('Shipment.partyFrom'),
        partyTo: this.$t('Shipment.partyTo'),
        Shipment: this.$tc('Shipment._name', 1),
        pickupDelivery: this.$t('Shipment.pickupDelivery'),
        files: this.$tc('DocumentRequest._name', 1),
        shipmentItems: this.$t('Shipment.shipmentItems'),
        responsibilities: this.$t('Shipment.responsibilities'),
        packages: this.$t('Shipment.packages'),
        history: this.$t('Shipment.history'),
        summary: this.$t('Shipment.summary'),
        comments: this.$t('Shipment.comments'),
      });
    },
    fullEntity() {
      let entity = {...this.shipmentEntity}
      let allFields = [...this.customAdditionalTabs, ...this.shipmentEntity.fields];
      // get all non last tabs
      let fields = _(allFields).sortBy((obj) => _.indexOf(this.tabsOrder, obj.name))
        .filter(f => !this.endTabs.includes(f.name));
      // get last tabs and order according to the endtabs data field
      let endTabs = _(allFields).filter(f => this.endTabs.includes(f.name))
        .sortBy((f) => _.indexOf(this.endTabs, f.name)).value();
      // set extras to the end
      entity.fields = fields.value().sort((f1, f2) => {
        if (f1.extra && f2.extra) return 0;
          if (f1.extra && !f2.extra) return 1;
          if (!f1.extra && f2.extra) return -1;
          return 0;
      });
      // append endtabs
      entity.fields.push(...endTabs);
      return entity;
    },
    hasDraftPermission() {
      return this.$store.state.schema.all.find(e => e.name == 'Draft').actions.create;
    },
    entityName () {
      return 'Shipment'
    },
    shipmentEntity () {
      return this.$searchEntity('Shipment', 'name', false)
    },
    uid () {
      return this.$route.params.item
    },
    shipmentIgnoreTabs() {
      return [...this.permIgnore, ...(this.uid ? [] : this.onAddIgnore), ...this.quoteIgnore];
    },
    partyFromId() {
      return this.instance && this.instance.partyFrom && this.instance.partyFrom.id
    },
    partyToId() {
      return this.instance && this.instance.partyTo && this.instance.partyTo.id
    },
    portalEntity() {
      return this.$findEntity(this.portal);
    },
    portalFinalObject() {
      return this.configEntity(this.portalEntity, this.fullEntity);
    },
    isEditing() {
      return this.instance && this.instance.entityState == 3;
    }
  },
  methods: {
    /**
     * @param {Date} date
     * @param {String} key
     */
    mapErrors(errors = {}) {
      this.tabsWithErrors = []
      const pickupDeliveryFields = ['timeZone', 'specificPickupTime', 'specificDeliveryTime', 'datePickupFrom', 'datePickupTo', 'dateDeliveryFrom', 'dateDeliveryTo'];
      const rootFields = ['shipperReference', 'receiverReference'];
      const packageFields = ['packages'];
      const packageContentFields = ['packagesContents', 'packageContents', 'shipmentItems'];
      if (_.keys(errors).some(r=> _.some(pickupDeliveryFields, v => r.includes(v)))) this.tabsWithErrors.push('pickupDelivery');
      if (_.keys(errors).some(r=> _.some(rootFields, v => r.includes(v)))) this.tabsWithErrors.push('Shipment');
      if (_.keys(errors).some(r=> _.some(packageFields, v => r.includes(v)))) this.tabsWithErrors.push('packages');
      if (_.keys(errors).some(r=> _.some(packageContentFields, v => r.includes(v)))) this.tabsWithErrors.push('shipmentItems');
    },
    handleFiles(val) {
      const fd = new FormData()

      val.map(f => {
        fd.append('files', f.file)
        fd.append('types', f.fileType)
        fd.append('documentRequestIds', f.documentRequestId)
      })
      fd.append('entity', 'Shipment')
      this.filesToUpload = val
      this.filesFormData = fd
    },

    saveDraft() {
      if(this.$refs.packageContents){
        this.$refs.packageContents.isDraft = true
        if(this.instance.packages) this.removePackageContentsbyPackage()
      }
      this.saveAsDraft();
    },
    /*
    Set ShipmentItems value in order to validate HTSCodeExport and HTSCodeImport extraFields
    */
    setShipmentItemsToValidateASN(){
      if(this.isASN){
        this.instance.shipmentItems.forEach(s => {
            s.isASN = this.isASN,
            s.PartyFromCountryName = this.instance.partyFrom.countryName,
            s.PartyToCountryName = this.instance.partyTo.countryName
        });
      }
    },
    /* TODO: docs */
    async save () {
      try {
        this.loading = true
        if(this.$refs.packageContents) {
          // if(this.instance.packages) this.removePackageContentsbyPackage()
        }
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId()
        if (this.instance.shipmentContacts == null) this.instance.shipmentContacts = [];
        this.setShipmentItemsToValidateASN();

        //Set documentsRequestsToUpload in order to validate Files
        this.instance.documentsRequestsToUpload = this.filesToUpload.map(f => ({DocumentRequestId: f.documentRequestId,FileName: f.file.name}))

         //Remove the "mirror" ExtraFields entity to avoid tracking issues with EF
        var clonedInstance = _.cloneDeep(this.instance);
        if(clonedInstance.extraData)
        {
          clonedInstance.extraData.forEach( ed => {
            if(ed.extraField) {
              ed.extraField = null;
            }
          });
        }

        if(this.$route.fullPath.includes('duplicate')){
          this.setPackageContentsWhenDuplicate(clonedInstance);
        }

        this.instance = (await axios.post('entity/graph', clonedInstance)).data
        try {
          if(this.filesFormData != null && this.filesFormData.has('files')){
            await axios.post(`file/media/${this.instance.id}`, this.filesFormData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }
          this.redirectAfterSave();
        } catch (error) {
          if (this.instance.id && error.response != null && error.response.config.url.includes("file/media")) {
            this.dialogWarningFiles = true;
            //this.redirectAfterSave();
            // this.instance.entityState = 3;
          }
        }
      } catch (error) {
          const requestErrors = _.get(error, 'response.data.errors');
          if (requestErrors) {
            this.errors = error.response.data.errors;
            this.mapErrors(requestErrors)
          }
          console.log(`[Shipment][save] error`, this.$cleanString(error))
        } finally {
          this.loading = false
        }
    },

    redirectAfterSave()
    {
      if (_.get(this.$route, 'query.workstation')) {
        this.$router.push({
          name: 'home',
        });
      } else {
        let routeName = this.portal ? 'shipment.portal' : 'shipment.index';
        this.$router.push({
          name: routeName,
          params: { portal: this.portal },
        });
      }
    },

    /*
    Delete all PackageContents if its package has been deleted
    */
    setDeletePackageContentsbyPackage() {
      if (this.instance.packages) {
        for (var i = 0; i < this.instance.packages.length; i++) {
          if(this.instance.packages[i].entityState == 2 && this.instance.packages[i].packageContents){
            for (var j = 0; j < this.instance.packages[i].packageContents.length; j++) {
              this.instance.packages[i].packageContents[j].entityState = 2
            }
          }
        }
      }
    },

    //If isDuplicated, set PackageContent (quantity) instance
    setPackageContentsWhenDuplicate(clonedInstance){
      clonedInstance.packages.forEach(p => {
        p.packageContents.forEach(pc => {
          let packageByItemNo = clonedInstance.packageContents.find(x => x.itemNo == pc.itemNo && x.packageId == pc.packageId);
          pc.quantity = packageByItemNo.quantity;
        });
      });
    },

    /*
    Remove all PackageContents if its package has been deleted THIS IS FOR DRAFTS
    */
   removePackageContentsbyPackage(){
      if (this.instance.packages) {
        for (var i = 0; i < this.instance.packages.length; i++) {
          if(this.instance.packages[i].entityState == 2){
            this.instance.packages.splice(i, 1);
          }
        }
      }
    },
    /* TODO: docs */
    async load () {
      // If the page is editing a draft, loads it and populate the draft info.
      if((await this.loadDraft())) {
        this.permIgnore.push('history', 'comments');
        // clean ids
        delete this.instance.id;
        delete this.instance.externalId;
        delete this.instance.uid;
        this.instance.entityState= 4;

        return;
      }
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entityName}/${this.uid}`, true, ...this.loads)
          let _instance = (await axios.get(endpoint, {
            _Entity: this.entityName,
            uid: this.uid
          })).data
          _instance = {
            ..._instance,
            normalizePackageContents: true,
            entityState: 3,
          };

          this.instance = _instance;
          this.processes = [...new Set((this.instance.orderLines || []).map(l => l.process && l.process.name))];
          const { status } = this.instance;
          ({ blockEdit: this.blockEdit } = status || {});
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        // clean state
        // let stateInstance = {...this.instance}
        this.permIgnore.push('history', 'comments');
        this.instance = {
          ...this.instance,
          id: null,
          externalId: null,
          uid: null,
          entityState: 4,
          partyFrom: {contactParties:[]},
          partyTo: {contactParties:[]},
          packages: [],
          shipmentContacts: [],
          specificPickupTime: false,
          specificDeliveryTime: false,
          createdAt: null,
          modifiedAt: null,
          shipperReference: null,
          receiverReference: null,
          isASN: false,
          files: [],
        }
        //console.log(this.instance);
        delete this.instance.id;
        delete this.instance.uid;
        delete this.instance.externalId;
        if (!this.$store.state.asnOrderLines && !this.$route.params.Asn) {
          // this.instance.shipmentItems = [];
          this.$store.commit('SET_INSTANCE_PATH', { path: `packages`, value: [{ packageNo: this.$generateUid(), entityState: 4, _Entity: 'Package' }] });
          this.$store.commit('SET_INSTANCE_PATH', { path: `shipmentItems`, value: [] });
        }
        else{
          this.isASN = true
          await this.createByAsn();
        }
        this.loading = false;
      }
    },
    async createByAsn() {
      this.setAsnTimes();
      //Create a shipment loaded with the information from ASN table
      this.asnShipment = await this.createAsnShipment();

      this.$store.commit('SET_INSTANCE', this.asnShipment)
      let defaultShipmentItems = this.mapAsnShipmentItems();
      let packages = [{ _Entity: 'Package', packageNo: this.$generateUid(), entityState: 4 }];
      this.$store.commit('SET_INSTANCE_PATH', { path: `shipmentItems`, value: defaultShipmentItems });
      this.$store.commit('SET_INSTANCE_PATH', { path: `packages`, value: packages });
      this.$store.state.asnOrderLines = null;
    },
    /*
    Load a shipment with information from ASN table
    */
    async createAsnShipment() {
      var extraDataAsn = await this.GetExtraDataForAsnShipment();
      return {
        entityState: 4,
        _Entity: this.entity.name,
        user: this.$store.state.user.user,
        businessScope: this.shipmentBusinessScope,
        businessScopeId: this.shipmentBusinessScopeId,
        partyFrom: this.$store.state.asnOrderLines[0].collectionPoint,
        partyTo: this.$store.state.asnOrderLines[0].deliveryPoint,
        datePickupFrom: this.instance.datePickupFrom,
        datePickupTo: this.instance.datePickupTo,
        specificPickupTime: true,
        dateDeliveryFrom: this.instance.dateDeliveryFrom,
        dateDeliveryTo: this.instance.dateDeliveryTo,
        specificDeliveryTime: true,
        isASN: true,
        shipmentContacts: [],
        extraData: extraDataAsn,
        packageContents: [],
        normalizePackageContents: true,
      };
    },
    /*
    Call to endpoint to set an extraData ready to set to the shipment
    */
    async GetExtraDataForAsnShipment(){
      var extraDataResult = await axios.post('orderLines/GetExtraDataFromASN', this.$store.state.asnOrderLines)
      return extraDataResult.data
    },
    mapAsnShipmentItems() {
      return this.$store.state.asnOrderLines.map(ol => ({
        _Entity: 'ShipmentItem',
          entityState: 4,
          selected: "orderLine",
          itemNo: this.$generateUid(),
          orderLine: ol,
          product: ol.product,
          orderLineId: ol.id,
          productId: ol.productId
        }));
    },
    setAsnTimes() {
      const now = moment();
      this.instance.datePickupFrom = now.clone().hours(9).minutes(0).seconds(0).utc().format();
      this.instance.datePickupTo = now.clone().hours(17).minutes(0).seconds(0).utc().format();

      let dateDelivery = this.$store.state.asnOrderLines[0].dateDeliveryFrom;
      if (dateDelivery) {
        dateDelivery = moment(dateDelivery);
        this.instance.dateDeliveryFrom = dateDelivery.clone().hours(9).minutes(0).seconds(0).utc().format();
        this.instance.dateDeliveryTo = dateDelivery.clone().hours(17).minutes(0).seconds(0).utc().format();
      }
    },
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },
    overridePortalFields(fieldName, fields) {
      if (!fields) return this.$camelToString(fieldName);
      let field = fields.find(f => f.name === fieldName);
      return (field || {}).label || this.$camelToString(fieldName);
    },
    showPortalField(fieldName, fields) {
      // console.log('fieldName',  fieldName);
      // console.log('fields ', fields);
      // console.log('portal ', this.portal);
      if (_.isEmpty(this.portal)) return true;
      // console.log('field ', (fields || []).find(f => f.name === fieldName))
      return (fields || []).find(f => f.name === fieldName);
    },
    configEntity(portal, baseEntity) {
      if (_.isEmpty(portal)) return baseEntity

      const copyEntity = _.cloneDeep(baseEntity);
      const copyPortal = _.cloneDeep(portal);
      const entityFields = copyEntity.fields || [];
      const portalFields = copyPortal.fields.map(p => {
        if(p.extra) {
          let group = _.cloneDeep(this.$findEntity(p.name));
          group.fields = group.fields.filter(f => p.fields.some(pf => pf.extraFieldId == f.extraFieldId));
          return group;
        }
        return p;
      }) || [];
      // GET SORTED TABS
      const tabs = portalFields.filter(f => !f.primitive && !f.section && !f.extra);
      const sortedTabs = _.sortBy(tabs, 'uiSequence');

      // GET EXTRA FIELDS
      const extraFieldsGroups = portalFields.filter(f => f.extra);

      // PROCESS TABS TO HIDE NON REQUIRED ONES
      const processedTabs = _.reduce(sortedTabs, (acc, { name }) => {
        if (name == 'extraFields') {
          if (extraFieldsGroups && extraFieldsGroups.length > 0) return [...acc, ...extraFieldsGroups];
          return acc;
        }
        let found = entityFields.find(tab => tab.name == name);
        if (found) return [...acc, { ...found }];
        return acc;
      }, []);

      // GET Primitives
      const primitives = portalFields.filter(f => f.primitive);
      const processedPrimitives = _.reduce(primitives, (acc, { name, label }) => {
        let found = entityFields.find(primitive => primitive.name == name);
        if (found) return [...acc, { ...found, label }];
        return acc;
      }, []);

      const finalFields = [...processedTabs, ...processedPrimitives];
      // console.log('Final Fields ', finalFields.map(x => `${x.name} ${x.label}`));
      return { ...baseEntity, fields: finalFields };
    },
    redirectToIndex() {
      let routeName = this.portal ? 'shipment.portal' : 'shipment.index';
      this.$router.push({
        name: routeName,
        params: { portal: this.portal },
      });
    },
    updateComments(comments) {
      this.instance.comments = comments;
    },
    /**
     * This method rebuilds the package numbers in the shipment, in case that the package contents
     * do not have it the package contents section will not display and behave correctly
     * this codes sets a package number in the packages only if its not set, then for each
     * package content it sets the package no (if its not already set), for the shipment's
     * root package contents it is also set (the shipment has the package contents at the root)
     * @param {*} packages packages to rebuild their packageNo
     * @param {*} packageContents packagecontents from shipment's root
     */
    initPackageNos(packages = [], packageContents = []) {
      if(packages == null) return;
      packages.map((p, pi) => {
        if (p.packageNo == null || p.packageNo.trim().length == 0) {
          p.packageNo = this.$generateUid();
          p.entityState = 3; // set as modified
        }
        if (p.packageContents != null) {
          p.packageContents.map((pc, pci) => {
            pc.packageNo = p.packageNo;
            pc.entityState = 3; // set as modified
            let packageContentFromRoot = packageContents.find(contentFromRoot =>  contentFromRoot.id == pc.id);
            packageContentFromRoot.packageNo = pc.packageNo;
            packageContentFromRoot.entityState = 3; // set as modified
          })
        }
      })
      this.$store.commit('SET_INSTANCE_PATH', { path: "packages", value: packages });
    }
  },
  async created() {
    this.shipmentBusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    this.shipmentBusinessScope = await this.getBusinessScope(this.shipmentBusinessScopeId);
    const sPortal = !isEmpty(this.portal) ? this.portal : '';

    this.$store.commit('SET_INSTANCE', { entityState: 4,
                                        _Entity: 'Shipment',
                                        user: this.$store.state.user.user,
                                        businessScopeId: this.shipmentBusinessScopeId,
                                        businessScope: this.shipmentBusinessScope,
                                        portal: sPortal,
                                        normalizePackageContents: true,
                                        });
    await this.load();
    this.initPackageNos(this.instance.packages, this.instance.packageContents);
    this.isFirstLoad = false;
  },
}
</script>
